export default __webpack_public_path__ + "static/media/3595.ae4a4a70.png";